import { Injectable } from '@angular/core';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { AppConfig } from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class StripeService {
  private stripePromise: Promise<Stripe | null> | null = null;

  constructor(private appConfig: AppConfig) {}

  getStripe(): Promise<Stripe | null> {
    if (!this.stripePromise) {
      const spk = this.appConfig.getConfig("stripe_public_key");
      this.stripePromise = loadStripe(spk);
    }
    return this.stripePromise;
  }
}